module.exports = __webpack_public_path__ + "img/1.82f980bb.jpg";